<template>
  <div class="container-fluid">
    <navigation 
      ref="nav"      
      :user-info="this.user.profile" 
      @logout="logout" />
    
    <!-- Page Content -->
    <div class="blured-body" v-if="isSearchOpened"></div>
    <main class="page-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import Navigation from './components/Navigation'
import { mapActions, mapState } from 'vuex'
import { name as userModuleName } from '@/modules/user/store/'
import alert from '@/mixins/alert.mixin';
import store from '@/store';

export default {
  name: 'MainLayout',
  components: {
    navigation: Navigation
  },
  mixins: [alert],
  data() {
    return {
      isSearchOpened: false,
      sessionExpired: false
    }
  },
  computed: {
    ...mapState(userModuleName, ['userMenu', 'menuItemId', 'user']),
  },
  watch: {
    sessionExpired(newValue) {
      if (newValue) {
        this.showCloseAlert();
      }
    },
  },
  async mounted() {
    this.activateActivityTracker();
    if (store.state.$_user.isLoggingOut) {
      this.showCloseAlert();
    }
    window.location.hash = '';    
  },  
  methods: {
    ...mapActions(userModuleName, ['setMenuItemId', 'logout']),
    async showCloseAlert() {
      this.ShowAlert(
        'La sesión ha expirado',
        'Debe iniciar sesión nuevamente para continuar.',
        'error',
        async () => {
          await store.dispatch('$_user/logout');
        }
      );
    },   
    activateActivityTracker() {
      window.addEventListener('mousemove', this.userActivityThrottler);
      window.addEventListener('scroll', this.userActivityThrottler);
      window.addEventListener('keydown', this.userActivityThrottler);
      window.addEventListener('resize', this.userActivityThrottler);
      window.addEventListener('beforeunload', this.deactivateActivityTracker);
    },
    deActivateActivityTracker() {
      window.removeEventListener('mousemove', this.userActivityThrottler);
      window.removeEventListener('scroll', this.userActivityThrottler);
      window.removeEventListener('keydown', this.userActivityThrottler);
      window.removeEventListener('resize', this.userActivityThrottler);
      window.removeEventListener(
        'beforeunload',
        this.deactivateActivityTracker
      );
    },
    userActivityThrottler() {
      if (!this.sessionExpired) {
        clearTimeout(this.userActivityThrottlerTimeout);
        this.userActivityThrottlerTimeout = setTimeout(() => {
          this.handleSessionExpiration();
          clearTimeout(this.userActivityThrottlerTimeout);
        }, process.env.VUE_APP_SESSION_TIMEOUT * 60000);
      }
    },
    async handleSessionExpiration() {
      this.sessionExpired = true;
      await store.commit('$_user/SET_USER_LOGOUT');
    },
  },
}
</script>

<style scoped>

#main {
  margin-bottom: 30px;
}

.page-content {
  padding: 100px 30px;
}

.blured-body {
  left: 119px;
  top: 100px;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 11;
}

.blured-body {
  backdrop-filter: blur(8px);
}
</style>
